"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { useCookie, useSearchGroup } from "@travel/shared/hooks";
import { CampaignCookie } from "../global-cookies";
var UTM_PARAMS = [
    "utm_source",
    "utm_medium",
    "utm_content",
    "utm_id",
    "utm_placement",
    "utm_path",
];
var GLOBAL_PARAMS = __spreadArray([
    "campaign",
    "ad",
    "cid",
    "vanity"
], __read(UTM_PARAMS), false);
var GlobalParamsContext = createContext([
    {},
    {
        update: function () { },
        clearCampaign: function () { },
    },
]);
export function GlobalParamsProvider(_a) {
    var children = _a.children, initialParams = __rest(_a, ["children"]);
    var _b = __read(useSearchGroup(GLOBAL_PARAMS), 1), globalSearchParams = _b[0];
    var _c = __read(useCookie(CampaignCookie), 2), _d = _c[0], campaignCookie = _d === void 0 ? "" : _d, setCampaignCookie = _c[1];
    var globalParams = useMemo(function () {
        return computeGlobalParamsValue(globalSearchParams, initialParams, campaignCookie);
    }, [globalSearchParams, campaignCookie]);
    var _e = __read(useState(globalParams), 2), params = _e[0], setParams = _e[1];
    console.log({ globalParams: globalParams, params: params });
    var update = useCallback(function (params, strict) {
        if (strict === void 0) { strict = true; }
        var nextCookieValue = computeGlobalParamsLocalValue(params, initialParams, campaignCookie);
        if (strict && !nextCookieValue)
            return;
        if (nextCookieValue !== campaignCookie) {
            setCampaignCookie(nextCookieValue, {
                maxAge: 60 * 60 * 24 * 30,
            });
            setParams(params);
        }
    }, [campaignCookie]);
    var clearCampaign = useCallback(function () {
        setCampaignCookie(undefined);
        setParams({});
    }, []);
    useEffect(function () {
        update(globalParams);
    }, [globalParams]);
    return (_jsx(GlobalParamsContext.Provider, { value: [
            params,
            {
                update: update,
                clearCampaign: clearCampaign,
            },
        ], children: children }));
}
function computeGlobalParamsValue(params, initialParams, cookie) {
    var cookieValues = typeof cookie === "string" ? cookie === null || cookie === void 0 ? void 0 : cookie.split("_") : [];
    var globalParams = GLOBAL_PARAMS.reduce(function (acc, param, index) {
        var initialValue = initialParams[param];
        var queryValue = params[param];
        var cookieValue = cookieValues[index];
        var value = Array.isArray(queryValue)
            ? queryValue[0]
            : queryValue || initialValue || cookieValue || "";
        acc[param] = value;
        return acc;
    }, {});
    return globalParams;
}
function computeGlobalParamsLocalValue(params, initialParams, cookie) {
    var cookieValues = typeof cookie === "string" ? cookie === null || cookie === void 0 ? void 0 : cookie.split("_") : [];
    var empty = "||EMPTY||";
    var globalParamsValue = GLOBAL_PARAMS.reduce(function (acc, param, index) {
        var initialValue = initialParams[param];
        var cookieValue = cookieValues[index];
        var value = params[param] || initialValue || cookieValue || empty;
        if (!!acc) {
            acc += "_";
        }
        acc += value;
        return acc;
    }, "").replaceAll(empty, "");
    return !!globalParamsValue.replace(/\_/g, "") ? globalParamsValue : "";
}
export function useGlobalParams() {
    return useContext(GlobalParamsContext);
}
//@TODO: Refactor in favor of useGlobalParams
export var useGlobalSearchParams = useGlobalParams;
